import React from 'react';
export function DigitalGovernance() {
  return <div className="bg-white py-12" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4" data-id="element-38">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-39">
          <div data-id="element-40">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-41">
              Governança Digital
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-42">
              Transformação digital dos serviços marítimos e portuários
            </p>
            <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-43">
              Ver mais
            </button>
          </div>
          <div className="relative h-80 rounded-lg overflow-hidden" data-id="element-44">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600" alt="Governança Digital" className="w-full h-full object-cover" data-id="element-45" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-46">
              <h3 className="text-xl font-bold mb-2" data-id="element-47">
                Plataforma de Dados Marítimos
              </h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-48">
                Explorar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}